import { render } from "./ContattiList.vue?vue&type=template&id=015ce017&scoped=true"
import script from "./ContattiList.vue?vue&type=script&lang=js"
export * from "./ContattiList.vue?vue&type=script&lang=js"

import "./ContattiList.vue?vue&type=style&index=0&id=015ce017&scoped=true&lang=css"
import "../../assets/css/staff-contacts-mobile.css?vue&type=style&index=1&id=015ce017&scoped=true&lang=css&external"
import "../../assets/css/staff-contacts-search.css?vue&type=style&index=2&id=015ce017&scoped=true&lang=css&external"
import "../../assets/css/staff-editor-dialog.css?vue&type=style&index=3&id=015ce017&scoped=true&lang=css&external"
import "../../assets/css/staff-contact-dialog.css?vue&type=style&index=4&id=015ce017&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015ce017"]])

export default __exports__